export default {
	old_password: '',
	new_password: '',
}
